export default {
  meta: {
    title: '日报提交记录',
    url: '/abside/dailyrecord', // 埋点字段，上报归属的模块
    urlName: 'ab侧-日报提交记录', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
